export default {"src":"/_next/static/media/japan.359642fc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};